import React, { useState, useEffect } from 'react';
import ReactCodeInput from 'react-code-input';
import { observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';

import { LoginLoc } from '../../loc/login';
import { loc } from '../../lib/loc';
import { useStores } from '../../hooks/use-stores';

import ErrorMessage from '../../interface/ErrorMessage';
// import PreloadButton from './PreloadButton';

const SMSCodeForm = observer(() => {
    const [timer, setTimer] = useState(59);
    const { RecoveryStore: store } = useStores();
    const { errorMessage, onChange, phone, recoverPassword, success } = store || {};

    const resendCode = e => {
        e.preventDefault();
        recoverPassword(phone);
    };

    useEffect(() => {
        const countdown = setInterval(() => timer > 0 && setTimer(prevState => prevState - 1), 1000);

        return () => clearInterval(countdown);
    }, [timer]);

    // onSubmit(e) {
    //   e.preventDefault();
    //   this.send(this.state.code);
    // }

    return (
        <div className="pt-80 pb-150">
            {success && <Redirect to={'/login/recovery/success'} />}
            <form className="login-form " style={{ margin: 'auto', width: '410px' }}>
                <p style={{ marginBottom: '15px' }}>{loc(LoginLoc.recoveryPhoneCodeMessage, { phone })}</p>
                {errorMessage && <ErrorMessage message={errorMessage} />}
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <ReactCodeInput type="number" fields={6} autoFocus={true} onChange={onChange} />
                </div>
                {/*<div className="login-form__wrap-login-btn" style={{marginBottom: "30px"}}>*/}
                {/*    <PreloadButton*/}
                {/*        isLoad={load}*/}
                {/*        disabled={code == null || code.length < 5}*/}
                {/*    >*/}
                {/*        {loc(LoginLoc.send)}*/}
                {/*    </PreloadButton>*/}
                {/*</div>*/}
                <div>
                    {timer > 0 ? loc(LoginLoc.resetCode, { timer }) : <button onClick={resendCode}>{loc(LoginLoc.resendCode)}</button>}
                </div>
            </form>
        </div>
    );
});

export default SMSCodeForm;
